import { NewDraftParams, Withdraw } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent/draft'

import type { Request } from '../../../../index'


type ParamsApi = {
  student_id: number
  food_supplier_id: number
  data: {
    bik: string
    checking_account: string
    parent_phone: string
    parent_address: string
  },
  value: number
}

export const convertParams = ({
  studentID,
  supplierID,
  bik,
  checkingAccount,
  parentPhone,
  parentAddress,
  value,
}: NewDraftParams): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
    food_supplier_id: parseInt(supplierID, 10),
    data: {
      bik,
      checking_account: checkingAccount,
      parent_phone: parentPhone,
      parent_address: parentAddress,
    },
    value,
  }, null]
}

export const convertResult = (id: number): Withdraw => {
  return {
    withdrawID: String(id),
  }
}

export const POST_COMPENSATION_WITHDRAW_ORDERS_SAVE_DRAFT: Request<NewDraftParams, Withdraw, void> = [
  'cabinet/compensation/withdraw_orders/save_draft',
  'post',
  ['data', 'withdraw_order_id'],
]
